/* eslint-disable no-param-reassign */
import { useState } from 'react';
import api from '~/services';
import log from '~/helpers/log';

export default function useNewContact(values = false) {
  const [newContact, setNewContactValue] = useState(values);
  const [errorNewContact, setErrorNewContact] = useState();

  async function setNewContact(data) {
    try {
      // If email is invalid
      if (data?.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data?.email)) {
        setErrorNewContact('Invalid email format.');
      } else {
        const response = await api.contacts.post.newContact(data);
        if (response.data[0].error) {
          setErrorNewContact(response.data[0].error.message);
        } else {
          setNewContactValue(true);
          setErrorNewContact(undefined);
        }
      }
    } catch (err) {
      log.error('Failed to create new contact.', err);
      setNewContactValue(false);
    }
  }

  return [{ newContact, errorNewContact, setErrorNewContact }, setNewContact];
}
